import { formatCPF, validateCPF } from '@wareclouds/frontend-common';
import { formatRut, validateRut } from '@wareclouds/frontend-common/b2c';

export function normalizeRutForPackageValidation(formattedRut) {
  if (!formattedRut || typeof formattedRut !== 'string') return '';
  return formatRut(formattedRut).replace(/\./g, '');
}

export function isRutValid(formattedRut) {
  const normalized = normalizeRutForPackageValidation(formattedRut);
  if (!normalized || !normalized.includes('-')) return false;
  return validateRut(normalized);
}

export function isCpfValid(value) {
  if (!value) return false;
  return validateCPF(formatCPF(String(value)));
}

export function normalizeCpfForApi(value) {
  if (!value || typeof value !== 'string') return '';
  return formatCPF(value).replace(/\D/g, '');
}

export function normalizeRutForApi(value) {
  if (!value || typeof value !== 'string') return '';
  return formatRut(value).replace(/\./g, '').replace(/-/g, '').toUpperCase();
}
